import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import regeneratorRuntime from "/builds/lululemon/global-digital-tech/content-and-education/ecom-web-app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { Provider as UrqlProvider } from "urql";
import Cookies from "js-cookie";
import cookie from "cookie";
import { v4 as uuid } from "uuid";
import { createUrqlClient, getUrqlConfig } from "@lululemon/ecom-common/src/util/urql-client";
import { composeDataMethods } from "@lululemon/mwa-utils";
import { convertToUnderscored, convertToCountryCode } from "@lululemon/mwa-i18n";
import { digitalData } from "@lululemon/ecom-core";
import NextRouter, { useRouter } from "next/router";
import Head from "next/head";
// TODO: Regional Accuracy - Phase 4 - Remove UsrLocale cookie
import { getLocaleForContext } from "@lululemon/ecom-common/src/util/locale-utils";
var withUrqlClient = function(Component) {
    var WithUrqlClient = function(_param) {
        var urqlFetchOptions = _param.urqlFetchOptions, props = _object_without_properties(_param, [
            "urqlFetchOptions"
        ]);
        var router = useRouter();
        var client = createUrqlClient(urqlFetchOptions);
        // client may be undefined on first server render
        if ((client === null || client === void 0 ? void 0 : client.fetchOptions) && typeof client.fetchOptions === "function") {
            var ref;
            var referringPage = (ref = {
                "/p/": "PDP",
                "/c/": "CDP"
            }) === null || ref === void 0 ? void 0 : ref[router.pathname.slice(0, 3)];
            var fetchOptions = client.fetchOptions();
            client.fetchOptions = function() {
                return _object_spread_props(_object_spread({}, fetchOptions), {
                    headers: _object_spread({
                        "x-lll-request-correlation-id": uuid()
                    }, referringPage && {
                        "x-lll-referrer": "Channel=Web,Page=".concat(referringPage)
                    }, fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.headers)
                });
            };
        }
        return /*#__PURE__*/ _jsx(UrqlProvider, {
            value: client,
            children: /*#__PURE__*/ _jsx(Component, _object_spread({}, props))
        });
    };
    return composeDataMethods(Component, {
        prepareInitialPropsContext: function() {
            var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(appContext) {
                var ctx, urqlFetchOptions, urqlClient;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ctx = appContext.ctx || appContext;
                            _ctx.next = 3;
                            return getUrqlConfig(ctx);
                        case 3:
                            urqlFetchOptions = _ctx.sent;
                            urqlClient = createUrqlClient(urqlFetchOptions);
                            ctx.urqlClient = urqlClient;
                            ctx.urqlFetchOptions = urqlFetchOptions;
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(appContext) {
                return _ref.apply(this, arguments);
            };
        }(),
        getInitialProps: function(param) {
            var ctx = param.ctx;
            return {
                urqlFetchOptions: ctx.urqlFetchOptions
            };
        }
    })(WithUrqlClient);
};
export { withUrqlClient };
var fetchOptions = {};
var fetch;
if (!process.browser) {
    fetch = require("node-fetch");
    var https = require("https");
    fetchOptions.agent = new https.Agent({
        keepAlive: true
    });
} else {
    fetch = window.fetch;
    if (window.globalUnblock) {
        NextRouter.events.on("routeChangeStart", window.globalUnblock);
    }
}
var getCookieString = function(ctx) {
    var ref, ref1;
    // Check if cookie already exists for the client.
    // If it does then we want to just pass that through.
    if (ctx === null || ctx === void 0 ? void 0 : (ref = ctx.req) === null || ref === void 0 ? void 0 : (ref1 = ref.cookies) === null || ref1 === void 0 ? void 0 : ref1.UsrLocale) {
        return ctx.req.headers.cookie;
    }
    // If the cookie does not exist we want to create that for them.
    var convertedNextLocale = convertToUnderscored(ctx === null || ctx === void 0 ? void 0 : ctx.nextLocale);
    var convertedCountry = convertToCountryCode(ctx === null || ctx === void 0 ? void 0 : ctx.nextLocale);
    return "UsrLocale=".concat(convertedNextLocale, "; sl=").concat(convertedCountry);
};
export var withWrappedFetch = function(Component) {
    // During SSR, create a fetch that forwards req cookies
    // and adds on the akamai access token and ecom correlation id
    var createBoundFetch;
    if (!process.browser) {
        createBoundFetch = function() {
            var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(param, accessToken, cookieString) {
                var req, locale;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            req = param.req, locale = param.locale;
                            return _ctx.abrupt("return", function(reqUrl) {
                                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                                return fetch(reqUrl, _object_spread_props(_object_spread({}, opts, fetchOptions), {
                                    headers: _object_spread_props(_object_spread({}, opts.headers || {}), {
                                        cookie: cookieString,
                                        "X-Akamai-Edgescape": req.header("X-Akamai-Edgescape"),
                                        "True-Client-IP": req.header("True-Client-IP"),
                                        "x-lll-access-token": accessToken,
                                        "x-lll-ecom-correlation-id": global.correlationId,
                                        usrLocale: locale
                                    })
                                }));
                            });
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_, accessToken, cookieString) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var WithWrappedFetch = function(props) {
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
    };
    return composeDataMethods(Component, {
        prepareInitialPropsContext: function prepareInitialPropsContext(appContext) {
            return _async_to_generator(regeneratorRuntime.mark(function _callee() {
                var ctx, accessToken, cookieString;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ctx = appContext.ctx || appContext;
                            if (process.browser) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 4;
                            return appContext.ctx.req.app.locals.getSecret("tf-contenteducation-akamai-token");
                        case 4:
                            accessToken = _ctx.sent;
                            cookieString = getCookieString(ctx);
                            _ctx.next = 8;
                            return createBoundFetch(appContext.ctx, accessToken, cookieString);
                        case 8:
                            ctx.fetch = _ctx.sent;
                            global.wrappedFetch = appContext.ctx.fetch;
                            _ctx.next = 13;
                            break;
                        case 12:
                            {
                                ctx.fetch = window.fetch;
                            }
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        }
    })(WithWrappedFetch);
};
export var withDigitalData = function(Component) {
    var cachedDigitalData;
    var WithDigitalData = function(props) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Head, {
                    children: /*#__PURE__*/ _jsx("script", {
                        dangerouslySetInnerHTML: {
                            __html: cachedDigitalData
                        }
                    })
                }),
                /*#__PURE__*/ _jsx(Component, _object_spread({}, props))
            ]
        });
    };
    return composeDataMethods(Component, {
        prepareInitialPropsContext: function prepareInitialPropsContext(appContext) {
            var ref, ref1;
            var ctx = appContext.ctx || appContext;
            var parsedCookies = ctx.req ? cookie.parse(((ref = ctx.req) === null || ref === void 0 ? void 0 : (ref1 = ref.headers) === null || ref1 === void 0 ? void 0 : ref1.cookie) || "") : Cookies.get() || {};
            digitalData.setGlobalData({
                country: parsedCookies.Country,
                geoRegion: parsedCookies.sl
            });
            cachedDigitalData = "window.DIGITAL_DATA=".concat(JSON.stringify(digitalData));
        },
        getInitialProps: function getInitialProps(appContext) {
            if (process.browser) {
                cachedDigitalData = "window.DIGITAL_DATA=".concat(JSON.stringify(window.DIGITAL_DATA));
            }
            return {
                digitalDataString: cachedDigitalData
            };
        },
        postProcessInitialProps: function postProcessInitialProps(appContext) {
            delete appContext.digitalDataString;
        }
    })(WithDigitalData);
};
export var withCommitHash = function(Component) {
    var WithCommitHash = function(props) {
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
    };
    return composeDataMethods(Component, {
        prepareInitialPropsContext: function prepareInitialPropsContext(appContext) {
            return _async_to_generator(regeneratorRuntime.mark(function _callee() {
                var ref;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            if (appContext === null || appContext === void 0 ? void 0 : (ref = appContext.ctx) === null || ref === void 0 ? void 0 : ref.res) {
                                appContext.ctx.res.setHeader("x-lll-client-commit", process.env.GIT_SHA);
                            }
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        }
    })(WithCommitHash);
};
// // TODO: RA Phase 1 - Exclude checking the URLs for locale that have not been regionalized
export var withLocale = function(Component) {
    var WithLocale = function(props) {
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
    };
    return composeDataMethods(Component, {
        prepareInitialPropsContext: function prepareInitialPropsContext(appContext) {
            return _async_to_generator(regeneratorRuntime.mark(function _callee() {
                var ctx, reqParams, usrLocale;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ctx = appContext.ctx || appContext;
                            reqParams = process.browser ? {
                                url: ctx.asPath,
                                query: ctx.query
                            } : {
                                req: ctx.req,
                                res: ctx.res
                            };
                            if (process.browser) {
                                console.debug("process.browser - skipping LDFlags at this step");
                            }
                            usrLocale = getLocaleForContext(reqParams, true, {
                                locale: ctx.locale
                            }); // Sets cookie
                            // Prior to enabling Next i18n, ctx.locale was populated based on query and cookie
                            // parameters.
                            // Now that we've enabled i18n, ctx.locale is auto-populated by Next.js, however,
                            // downstream consumers, like PDP, still need it to come in as it was before.
                            // Consumers that need to consume the Next's i18n locale can access it using the
                            // nextLocale prop for now.
                            // Possible values for ctx.locale comes from the next.config.js ("en-us", "en-ca", "fr-ca")
                            ctx.nextLocale = ctx.locale;
                            // Set locale back to the original expected value so that consumers like PDP continue
                            // functioning as expected.
                            ctx.locale = usrLocale;
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        }
    })(WithLocale);
};
